import generateFilterForQuery from './_tools';

export class DealCommonStatisticQuery {
  
  static build(query: any) {

    const filter = generateFilterForQuery(query);

    return {
      columns: DealCommonStatisticQuery.COLUMNS,
      from: DealCommonStatisticQuery.FROM,
      from_as: DealCommonStatisticQuery.FROM_AS,
      joins: DealCommonStatisticQuery.JOINS,
    //   groups: DealCommonStatisticQuery.GROUPS,
      // page_size: DealCommonStatisticQuery.PAGE_SIZE,
      ...({page: parseInt(query.page) || 1}),
    //   ...({
    //       order: [
    //         { $asc: [ 'pt.name' ] }
    //       ]
    //   }),
      where: {
        $and: [
            {
              $or: [
                { $null: [ 'status.final' ] },
                { $eq: [ 'status.final', { $: 'success'}]}
              ]
            },
            ...filter
          ]
    }
      
    }
  }

  static COLUMNS: any = {
    total_weight: {
        $sum: {
            $mul: [
            'pc.weight',
            'dcp.container_quantity'
            ]
        }
    },
    total_sum: {
        $sum: 'dcp.container_price'
    },
    total_quantity: {
        $sum: 'dcp.container_quantity'
    }
  };

  static FROM: string = 's:deals';
  static FROM_AS: string = 'deal';

  static JOINS: any[] = [
    {
        join: 's:employees',
        type: 'left',
        as: 'manager',
        on: {
            $eq: [
            'manager.id',
            'deal.manager_id'
            ]
        }
    },
    {
        join: 's:clients',
        type: 'left',
        as: 'client',
        on: {
            $eq: [
            'client.id',
            'deal.client_id'
            ]
        }
    },
    {
        join: 's:payment_deferment_periods',
        type: 'left',
        as: 'pdp',
        on: {
            $eq: [
            'pdp.id',
            'client.payment_deferment_period_id'
            ]
        }
    },
    {
        join: 's:payment_types',
        type: 'left',
        as: 'ptype',
        on: {
            $eq: [
            'deal.payment_type_id',
            'ptype.id'
            ]
        }
    },
    {
        join: 's:delivery_points',
        type: 'left',
        as: 'point',
        on: {
            $eq: [
            'deal.delivery_point_id',
            'point.id'
            ]
        }
    },
    {
        join: 's:cities',
        type: 'left',
        as: 'city',
        on: {
            $eq: [
            'point.city_id',
            'city.id'
            ]
        }
    },
    {
        join: 's:deal_product_containers',
        type: 'left',
        as: 'dcp',
        on: {
            $eq: [
            'dcp.deal_id',
            'deal.id'
            ]
        }
    },
    {
        join: 's:product_containers',
        type: 'left',
        as: 'pc',
        on: {
            $eq: [
            'pc.id',
            'dcp.product_container_id'
            ]
        }
    },
    {
        join: 's:products',
        type: 'left',
        as: 'p',
        on: {
            $eq: [
            'p.id',
            'pc.product_id'
            ]
        }
    },
    {
        join: 's:statuses',
        type: 'left',
        as: 'status',
        on: {
            $eq: [
            'deal.status_id',
            'status.id'
            ]
        }
    },
    {
        join: 's:delivery_points',
        type: 'left',
        as:   'delivery_points',
        on: {
            $eq: ['delivery_points.id', 'deal.delivery_point_id']
        }
    },
    {
    join: {
        columns: {
        deal_id: 'dpc.deal_id',
        sapmle_count: { $count: 'dpc.id' }
        },
        from: 's:deal_product_containers',
        from_as: 'dpc',
        joins: [
        {
            join: 's:product_containers',
            type: 'left',
            as:   'pc',
            on: {
            $eq: ['pc.id', 'dpc.product_container_id']
            }
        },
        ],
        groups: [
        'dpc.deal_id'
        ],
        where: {
        $or: [
            { $eq: ['dpc.is_sample', { $: true } ] },
            { $eq: ['pc.is_sample', { $: true } ] },
        ]
        }
    },
    type: 'left',
    as: 'dpc_with_samples',
    on: { $eq: ['dpc_with_samples.deal_id', 'deal.id'] }
    }
  ]

//   static GROUPS: any[] = [
//     'pt.id',
//     'pt.name'
//   ]
}


export function buildQueryDealsSumm(): any {
    return {
        columns: {
            total_weight: {
                $sum: {
                    $mul: [
                    'pc.weight',
                    'dcp.container_quantity'
                    ]
                }
            },
            total_sum: {
                $sum: 'dcp.container_price'
            },
            total_quantity: {
                $sum: 'dcp.container_quantity'
            }
        },
        from: 's:deals',
        from_as: 'deal',
        joins: [
            {
                join: 's:employees',
                type: 'left',
                as: 'manager',
                on: {
                    $eq: [
                    'manager.id',
                    'deal.manager_id'
                    ]
                }
            },
            {
                join: 's:clients',
                type: 'left',
                as: 'client',
                on: {
                    $eq: [
                    'client.id',
                    'deal.client_id'
                    ]
                }
            },
            {
                join: 's:payment_deferment_periods',
                type: 'left',
                as: 'pdp',
                on: {
                    $eq: [
                    'pdp.id',
                    'client.payment_deferment_period_id'
                    ]
                }
            },
            {
                join: 's:payment_types',
                type: 'left',
                as: 'ptype',
                on: {
                    $eq: [
                    'deal.payment_type_id',
                    'ptype.id'
                    ]
                }
            },
            {
                join: 's:delivery_points',
                type: 'left',
                as: 'point',
                on: {
                    $eq: [
                    'deal.delivery_point_id',
                    'point.id'
                    ]
                }
            },
            {
                join: 's:cities',
                type: 'left',
                as: 'city',
                on: {
                    $eq: [
                    'point.city_id',
                    'city.id'
                    ]
                }
            },
            {
                join: 's:deal_product_containers',
                type: 'left',
                as: 'dcp',
                on: {
                    $eq: [
                    'dcp.deal_id',
                    'deal.id'
                    ]
                }
            },
            {
                join: 's:product_containers',
                type: 'left',
                as: 'pc',
                on: {
                    $eq: [
                    'pc.id',
                    'dcp.product_container_id'
                    ]
                }
            },
            {
                join: 's:products',
                type: 'left',
                as: 'p',
                on: {
                    $eq: [
                    'p.id',
                    'pc.product_id'
                    ]
                }
            },
            {
                join: 's:statuses',
                type: 'left',
                as: 'status',
                on: {
                    $eq: [
                    'deal.status_id',
                    'status.id'
                    ]
                }
            },
            {
                join: 's:delivery_points',
                type: 'left',
                as:   'delivery_points',
                on: {
                    $eq: ['delivery_points.id', 'deal.delivery_point_id']
                }
            },
            {
            join: {
                columns: {
                deal_id: 'dpc.deal_id',
                sapmle_count: { $count: 'dpc.id' }
                },
                from: 's:deal_product_containers',
                from_as: 'dpc',
                joins: [
                {
                    join: 's:product_containers',
                    type: 'left',
                    as:   'pc',
                    on: {
                    $eq: ['pc.id', 'dpc.product_container_id']
                    }
                },
                ],
                groups: [
                'dpc.deal_id'
                ],
                where: {
                $or: [
                    { $eq: ['dpc.is_sample', { $: true } ] },
                    { $eq: ['pc.is_sample', { $: true } ] },
                ]
                }
            },
            type: 'left',
            as: 'dpc_with_samples',
            on: { $eq: ['dpc_with_samples.deal_id', 'deal.id'] }
            }
        ],
        where: {
            $and: [
                {
                  $or: [
                    { $null: [ 'status.final' ] },
                    { $eq: [ 'status.final', { $: 'success'}]}
                  ]
                }
              ]
        }
    }
}
